import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useTranslation } from 'react-i18next';
import useElDimensions from '../../../hooks/useElDimensions';
import usePropsBeforeContext from '../../../hooks/usePropsBeforeContext';
import { CalendarViewContext } from '../../Calendar';
import DefaultInterfacesHandler from '../../handlers/DefaultInterfacesHandler';

import { useDetailsViewLogic } from './useDetailsViewLogic';
import { DetailsViewProvider } from './DetailsViewContext';
import MobileLayout from './layouts/MobileLayout';
import DesktopLayout from './layouts/DesktopLayout';

/**
 * Main DetailsView component with flexible layout system
 * Allows different arrangements of detail components around the calendar
 */
export default function DetailsView(props) {
  const { t } = useTranslation();
  const contextProps = usePropsBeforeContext(props, CalendarViewContext);
  const { height } = contextProps;

  const [tslHeadlineRef, tslHeadlineDimensions] = useElDimensions();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const detailsLogic = useDetailsViewLogic(contextProps);

  const calendarHeight = tslHeadlineDimensions
    ? height - tslHeadlineDimensions.height
    : height;

  const layoutProps = {
    ...contextProps,
    ...detailsLogic,
    calendarHeight,
    tslHeadlineRef,
    calendarTitle: t('detailsView.chose_date_and_time'),
  };

  return (
    <DetailsViewProvider value={layoutProps}>
      {isSmallScreen ? <MobileLayout /> : <DesktopLayout />}
      <DefaultInterfacesHandler />
    </DetailsViewProvider>
  );
}
